import { getSaasApiBaseUrl } from '../utils/saasApiBaseUrl';

function authHeaders() {
  const token = localStorage.getItem('token') || localStorage.getItem('access_token') || localStorage.getItem('auth_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

async function request(path, options = {}) {
  const base = getSaasApiBaseUrl();
  const url = `${base}${path}`;
  const response = await fetch(url, {
    ...options,
    headers: { ...authHeaders(), ...(options.headers || {}) },
  });
  if (!response.ok) {
    let detail = response.statusText;
    try {
      const body = await response.json();
      detail = body.detail || detail;
    } catch {
      /* ignore */
    }
    throw new Error(typeof detail === 'string' ? detail : 'Request failed');
  }
  if (response.status === 204) return null;
  return response.json();
}

export function fetchOnboardingStatus() {
  return request('/onboarding/status');
}

export function completeOnboarding() {
  return request('/onboarding/complete', { method: 'POST' });
}

export function fetchOrganizationCurrent() {
  return request('/organizations/current');
}

export function updateOrganization(payload) {
  return request('/organizations/current', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function addOrganizationLocation(payload) {
  return request('/organizations/current/locations', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function seedDefaultScenario(organizationId) {
  return request('/onboarding/seed', { method: 'POST' });
}

export function seedScenario(scenarioId, organizationId) {
  return request(`/onboarding/scenarios/${encodeURIComponent(scenarioId)}/seed`, {
    method: 'POST',
    body: JSON.stringify({ organization_id: organizationId }),
  });
}

export function fetchOnboardingManifest(organizationId) {
  const qs = organizationId ? `?organization_id=${encodeURIComponent(organizationId)}` : '';
  return request(`/onboarding/manifest${qs}`);
}

export function completeChecklistItem(itemKey, organizationId) {
  const qs = organizationId ? `?organization_id=${encodeURIComponent(organizationId)}` : '';
  return request(`/onboarding/checklist/${encodeURIComponent(itemKey)}/complete${qs}`, {
    method: 'POST',
  });
}

export function listOnboardingScenarios(intent) {
  const qs = intent ? `?intent=${encodeURIComponent(intent)}` : '';
  return request(`/onboarding/scenarios${qs}`);
}
